import React from "react";
import { TextField } from "@mui/material";
import { motion } from "framer-motion";
import Select from "react-select";
import {
  Overlay,
  ModalHeader,
  PrimaryButton,
  SecondaryButton,
} from "../../../../components";
import { emailValidation } from "../../../../utils/utils";
import { Notify } from "../../../../components";
import { connect } from "react-redux";
import AddUserIcon from "../../../../assets/icons/add-new-user.svg";

const emailErrorMessage = "Enter valid Email";

const AddUser = ({
  showMessage,
  loggedUserDetails,
  addNewUserFn,
  onClose,
  rolesData = [],
}) => {
  const [userEmail, setUserEmail] = React.useState("");
  const [showError, setShowError] = React.useState(false);
  const [roleId, setRoleId] = React.useState(null);

  const filterRoles = rolesData.filter(
    (role) => role.roleName !== "System Administrator"
  );

  const roleOptions = filterRoles.map((data) => ({
    value: data.roleId,
    label: data.roleName,
  }));

  const handleSaveClick = () => {
    if (!emailValidation(userEmail)) {
      setShowError(true);
      return;
    }

    if (roleId && userEmail) {
      addNewUserFn({
        roleId,
        userEmail,
        dxAccountId: loggedUserDetails.dxAccountId,
      });
      onClose(false);
    } else {
      Notify({ value: "Fill all the feilds" });
    }
  };

  React.useEffect(() => {
    if (showMessage) {
      setUserEmail("");
      setShowError(false);
      setRoleId(null);
    }
  }, [showMessage]);

  return (
    <React.Fragment>
      <Overlay />
      <div className="prompt">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <ModalHeader
            title="Add new user"
            onClick={() => onClose(false)}
            img={AddUserIcon}
            alt="addUser"
          />

          <div className="modal_middle">
            <div className="form-group">
              <TextField
                placeholder="Email Address"
                name="email"
                value={userEmail}
                onChange={(e) => {
                  const value = e.target.value;
                  setUserEmail(value);
                  if (showError) {
                    setShowError(!emailValidation(value));
                  }
                }}
                autoFocus
                fullWidth
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    fontSize: "14px",
                    color: "#9E9EA6",
                    "& input": {
                      fontSize: "14px",
                      color: "#9E9EA6",
                    },
                    "& input::placeholder": {
                      textOverflow: "ellipsis",
                      color: "#000000",
                      fontSize: "14px",
                      opacity: 1,
                    },
                  },
                }}
              />
              {showError && (
                <p className="form-invalid-message">{emailErrorMessage}</p>
              )}
            </div>

            <div className="form-group">
              <Select
                options={roleOptions}
                className="stain-select"
                placeholder="Select the role"
                isSearchable={false}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    width: "100%",
                  }),
                  control: (provided, state) => ({
                    ...provided,
                    minHeight: "30px",
                    height: "30px",
                    fontSize: "14px",
                    color: "#9E9EA6",
                    boxShadow: "none",
                    borderColor: state.isFocused
                      ? provided.borderColor
                      : provided.borderColor,
                    "&:hover": {
                      borderColor: provided.borderColor,
                    },
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    height: "30px",
                    padding: "0 8px",
                  }),
                  input: (provided) => ({
                    ...provided,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    color: "#9E9EA6",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    fontSize: "14px",
                    color: "#9E9EA6",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    fontSize: "14px",
                    color: "#9E9EA6",
                  }),
                  indicatorsContainer: (provided) => ({
                    ...provided,
                    height: "30px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                onChange={(selectedOption) =>
                  setRoleId(selectedOption?.value || null)
                }
              />
            </div>
          </div>

          <div className="prompt-bottom" style={{ marginTop: 0 }}>
            <SecondaryButton label="Cancel" onClick={() => onClose(false)} />
            <PrimaryButton
              label="Invite"
              onClick={handleSaveClick}
              disabled={showError || !userEmail || !roleId}
              extraClass="prompt-done"
            />
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  rolesData: state.Dashboard.rolesData,
});

export default connect(mapStateToProps)(AddUser);